import React from 'react';
import { AnimatedTabs } from '@components/ui/animated-tabs';
import { SortDropdown } from './SortDropdown';
import type { TabId, SortOption } from '../types';

interface HomeTabBarProps {
  activeTab: TabId;
  onTabChange: (tab: TabId) => void;
  /** Undefined when the active tab has no sort concept (Meetverse) — the dropdown is hidden then. */
  sortBy: SortOption | undefined;
  onSortChange: (sort: SortOption) => void;
}

const TAB_OPTIONS = [
  {
    value: 'meetverse' as const,
    label: 'Meetverse',
    activeBgClassName: 'bg-mb-yellow-pale border border-mb-gold-border',
    activeTextClassName: 'text-mb-grey-450',
  },
  {
    value: 'my-spaces' as const,
    label: 'My Spaces',
    activeBgClassName: 'bg-mb-yellow-pale border border-mb-gold-border',
    activeTextClassName: 'text-mb-grey-450',
  },
];

export const HomeTabBar: React.FC<HomeTabBarProps> = ({
  activeTab,
  onTabChange,
  sortBy,
  onSortChange,
}) => {
  // Meetverse no longer exposes sorting — server decides order.
  const showSort = activeTab === 'my-spaces';

  return (
    <div className="flex items-center justify-between px-2.5">
      <AnimatedTabs
        value={activeTab}
        onValueChange={value => {
          onTabChange(value as TabId);
        }}
        options={TAB_OPTIONS}
        className="w-2/3 bg-mb-offwhite"
        tabClassName="text-xs font-semibold py-1.5 whitespace-nowrap p-2.5"
        inactiveClassName="text-mb-grey-300"
      />
      {showSort && sortBy && <SortDropdown value={sortBy} onChange={onSortChange} />}
    </div>
  );
};
